// Flags for multi-step auth flows that App.js's listeners must not interrupt.
//
// registering: set while Register creates the auth user and writes the
// users/companies docs. Without it, onAuthStateChanged fires before the user
// doc exists, App.js reads a missing doc and force-signs-out mid-registration
// (same race the mobile app fixed with authFlags.registering).
//
// deleting: set while the admin deletes their own account from Settings. The
// live company listener treats a missing company doc as "account removed" and
// would force-sign-out halfway through the deletion sequence.
export const authFlows = { registering: false, deleting: false };
